const items = [
  "Mariages",
  "Vins d'honneur",
  "Conférences",
  "Réceptions privées",
  "Maîtres d'hôtel",
  "Hôtes & hôtesses d'accueil",
  "Service d'exception",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((item, i) => (
      <span key={i} className="flex items-center">
        <span
          className={`whitespace-nowrap px-10 text-2xl tracking-tight sm:text-3xl ${
            i % 2 === 0 ? "font-display italic text-[#0a0a0a]" : "font-light uppercase tracking-[0.3em] text-[#0a0a0a]/40"
          }`}
        >
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#0a0a0a]/10 bg-[#f9f8f6] py-8">
    <div className="animate-marquee-slow flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
